
import { useContext, useMemo } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./Flare.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PumpContext } from "../context/PumpContext";
import FlareStackFlame from "../components/FlareStackFlame";

import { trackPageVisit } from "../competency/PageTracker";


 

 
      /* ✅ CONTROL VALVE PERCENTAGE OUTPUT Indicator */
                function ValveOutput({ value, x, y, r=0 }) {
                return (
                  <div
                    style={{
                      position: "absolute",
                      left: x,
                      top: y,
                      color: "white",
                      fontSize: "10px",
                      padding: "2px 6px",
                      borderRadius: "4px",
                      transform: `rotate(${r}deg)`,
                      transformOrigin: "center",
                      cursor: "pointer"
                    }}
                  >
                    {value.toFixed(1)}
                  </div>
                );
              }


function Flare() {

        useEffect(() => {
  
    trackPageVisit("Flare");
  
  }, []);

   const {  valves, toggleValve, transmitters} = useContext(WellContext);

       const { pumpData } = useContext(PumpContext);
   

  


  const DEFAULT_VALVES = {
  FCV_2971: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Flare_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_2971: { ...DEFAULT_VALVES.FCV_FCV_2971, ...parsed.FCV_2971 },
    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Flare_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };



  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};




// ================= RETREIVING STORED TRANSMITTERS FROM LOCAL STORAGE IN OTHER PAGES GOING TO FLARE HEADERS =================

  const [FIC_13007, setFIC_13007] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_13007")) || 0;
            setFIC_13007(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_12003, setFIC_12003] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_12003")) || 0;
            setFIC_12003(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


  const [FIC_14008, setFIC_14008] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_14008")) || 0;
            setFIC_14008(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_15008, setFIC_15008] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_15008")) || 0;
            setFIC_15008(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_18004, setFIC_18004] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_18004")) || 0;
            setFIC_18004(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2804, setFIC_2804] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2804")) || 0;
            setFIC_2804(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2805, setFIC_2805] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2805")) || 0;
            setFIC_2805(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


  const [FIC_2910, setFIC_2910] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2910")) || 0;
            setFIC_2910(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);


  const [FIC_2935, setFIC_2935] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2935")) || 0;
            setFIC_2935(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2303, setFIC_2303] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2303")) || 0;
            setFIC_2303(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2003, setFIC_2003] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2003")) || 0;
            setFIC_2003(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);

  const [FIC_2503, setFIC_2503] = useState(0);
        useEffect(() => {
          const interval = setInterval(() => {
            const value = Number(localStorage.getItem("FIC_2503")) || 0;
            setFIC_2503(value);
          }, 100); 
          return () => clearInterval(interval);
        }, []);





// ================= VALVE AND PUMPS INITIALIZATION AND STATUS =================
  const isXV2981Open = valves?.XV_2981 === false;
  const isXV2982Open = valves?.XV_2982 === false;
  const isXV2983Open = valves?.XV_2983 === false;

  const isP2981AOn = pumpData?.["P-2981A"]?.running ?? false;
  const isP2981BOn = pumpData?.["P-2981B"]?.running ?? false; 



  // ================= INFLOW LOGIC from TEST, FIRST STAGE, SECOND AND THIRD STAGE SEPARATOR to OILY WATER TANK LEVEL TRANSMITTER =================
     
    const FIC_2981 = isXV2982Open ? 6.987 : 0;
    
    const PT_2981 = isXV2982Open ? 0.987 : 0.03;

    const FIC_2982 = isXV2981Open ? FIC_2303 + FIC_13007 + FIC_12003 + FIC_14008 + FIC_15008 + FIC_18004 + FIC_2003 + FIC_2804 + FIC_2503 + FIC_2805 + FIC_2910 + FIC_2935 : 0;

    const PT_2982 = isXV2981Open ? 1.3 : 0.03;
    const PT_2983 = isXV2981Open ? PT_2982*0.978 : 0.03;
    
    const FIC_2983 = FIC_2982 * 0.90;

    const FIC_2985 = isXV2983Open ? 0.334 : 0;



    
                  useEffect(() => {
                      localStorage.setItem("FIC_2983", FIC_2983);
                    }, [FIC_2983]); 







    
  // ================= MAIN CORROSION INHIBITION INJECTION PUMPS =================
  const runningPumps2981 = [isP2981AOn, isP2981BOn].filter(Boolean).length;


// ================= SUCTION INPUTS =================
const suctionFlow2981 = 0;
const suctionPressure2981 = 0;

// ================= DESIGN LIMITS =================
const MAX_DISCH_PRESSURE_2981 = 1.2;
const MIN_DISCH_PRESSURE_2981 = 0.03;

// ================= TARGET CALCULATIONS =================
let targetPT_2984 = MIN_DISCH_PRESSURE_2981;
let targetFIC_2984 = 0;

if (runningPumps2981 > 0) {

  // 🔹 Flow boost
  targetFIC_2984 = 10;

  // 🔹 Pressure rises to design max
  targetPT_2984 = MAX_DISCH_PRESSURE_2981;

}

// ================= STATES =================
const [PT_2984, setPT_2984] = useState(() => {
  return Number(localStorage.getItem("PT_2984")) || 0.03;
});

const [FIC_2984, setFIC_2984] = useState(() => {
  return Number(localStorage.getItem("FIC_2984")) || 0;
});

// ================= SMOOTHING (DCS RESPONSE) =================
useEffect(() => {

  const interval = setInterval(() => {

    // 🔹 PRESSURE RESPONSE
    setPT_2984(prev => {
      const next = prev + (targetPT_2984 - prev) * 0.15;
      return Number(next.toFixed(3));
    });

    // 🔹 FLOW RESPONSE
    setFIC_2984(prev => {
      const next = prev + (targetFIC_2984 - prev) * 0.12;
      return Number(next.toFixed(2));
    });

  }, 100); // 🔥 fast response like DCS

  return () => clearInterval(interval);

}, [targetPT_2984, targetFIC_2984]);

// ================= SAVE TO LOCAL STORAGE =================
useEffect(() => {
  localStorage.setItem("PT_2984", PT_2984);
}, [PT_2984]);

useEffect(() => {
  localStorage.setItem("FIC_2984", FIC_2984);
}, [FIC_2984]);

// ================= LOAD SHARING (OPTIONAL DISPLAY) =================
const loadShare2951 =
  runningPumps2981 > 0 ? (100 / runningPumps2981).toFixed(0) : 0;

// Example (if you want to display per pump later):
const pumpAFlow =
  isP2981AOn && runningPumps2981 > 0
    ? FIC_2984 / runningPumps2981
    : 0;

const pumpBFlow =
  isP2981BOn && runningPumps2981 > 0
    ? FIC_2984 / runningPumps2981
    : 0;







  return (
    <div className="Flare-container"> 
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "0px",
        left: "260px",
        color: "white",
        background: "rgba(30, 6, 245, 0.97)", 
        padding: "2px 305px"
      }}>
        FLARE
      </h2>

      {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-2981 */}
      <Valve
        className="XV-2981"
        tag="XV_2981"
        x={128}
        y={172}
        isClosed={valves.XV_2981}
        toggle={toggleValve}
      />

      {/* XV-2982 */}
      <Valve
        className="XV-2982"
        tag="XV_2982"
        x={689}
        y={98}
        isClosed={valves.XV_2982}
        toggle={toggleValve}
      />

      {/* XV-2983 */}
      <Valve
        className="XV-2983"
        tag="XV_2983"
        x={475}
        y={564}
        isClosed={valves.XV_2983}
        toggle={toggleValve}
      />

      
      

          
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

          
          {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          {/* ================= TRANSMITTERS OUTPUTS ================= */}

  
      <Transmitter
          tag="FIC-2981"
          value={[FIC_2981]}
          x={497}
          y={89}
          unit="SCF/S"
          max={20}
          HH={15}
          H={5}
          L={1}
          LL={0.5}
          c="lime"
          description="FLOWRATE OF LEAN GAS FROM LEAN GAS SUPPLY HEADER"
        />
      <Transmitter
          tag="FIC-2982"
          value={[FIC_2982]}
          x={228}
          y={152}
          unit="SCF/S"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF GASES FROM FLARE HEADER TO FLARE KNOCK-OUT DRUM"
        />
      <Transmitter
          tag="FIC-2983"
          value={[FIC_2983]}
          x={945}
          y={292}
          unit="SCF/S"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF GASES FROM FLARE KNOCK-OUT DRUM TO FLARE STACK FOR BURNING"
        />
      <Transmitter
          tag="FIC-2984"
          value={[FIC_2984]}
          x={888}
          y={473}
          unit="LPM"
          max={100}
          HH={90}
          H={80}
          L={10}
          LL={5}
          c="lime"
          description="FLOWRATE OF RECOVERED LIQUID FLUID FROM KNOCKOUT DRUM TO OILY WATER TANK (CLOSE DRAIN)"
        />
      <Transmitter
          tag="FIC-2985"
          value={[FIC_2985]}
          x={1118}
          y={473}
          unit="SCF/S"
          max={2}
          HH={1.5}
          H={1}
          L={0.1}
          LL={0.05}
          c="lime"
          description="FLOWRATE OF LIQUIFIED PETROLUEM GAS (LPG) USED FOR PILOT IGNITION OF FLARE"
        />

     
      <Transmitter
          tag="PT-2981"
          value={[PT_2981]}
          x={347}
          y={89}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.2}
          LL={0.05}
          c="lime"
          description="PRESSURE OF LEAN GAS FROM LEAN GAS SUPPLY HEADER"
        />
      <Transmitter
          tag="PT-2982"
          value={[PT_2982]}
          x={148}
          y={152}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.2}
          LL={0.05}
          c="lime"
          description="PRESSURE OF GASES FROM FLARE HEADER TO FLARE KNOCK-OUT DRUM"
        />
      <Transmitter
          tag="PT-2983"
          value={[PT_2983]}
          x={365}
          y={200}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.2}
          LL={0.05}
          c="lime"
          description="PRESSURE OF FLARE KNOCK-OUT DRUM"
        />
      <Transmitter
          tag="PT-2984"
          value={[PT_2984]}
          x={880}
          y={398}
          unit="MPa"
          max={2}
          HH={1.8}
          H={1.6}
          L={0.2}
          LL={0.05}
          c="lime"
          description="PRESSURE OF RECOVERED LIQUID FLUID FROM KNOCKOUT DRUM TO OILY WATER TANK (CLOSE DRAIN)"
        />




        <Pump
        tag="P-2981A"
        x={742}
        y={385}
        rpm={1800}
        bladeCount={pumpData?.["P-2981A"]?.bladeCount || 6}
        size={pumpData?.["P-2981A"]?.size || 38}
        onClick={openPumpPanel}
      />
        <Pump
        tag="P-2981B"
        x={737}
        y={480}
        rpm={1800}
        bladeCount={pumpData?.["P-2981B"]?.bladeCount || 6}
        size={pumpData?.["P-2981B"]?.size || 45}
        onClick={openPumpPanel}
      />


    <LevelTransmitterIndicator
      tag="LT_2981"
      totalLevel={200000}
      inflows={[FIC_2982 * 0.1]}
      outflows={[FIC_2984]}
      responseFactor={0.05}
      columnX={192}
      columnY={250}
      columnWidth={379}
      columnHeight={104}
      textX={619}
      textY={258}
      showFlow={true}
      backgroundOpacity={0.1}
      liquidOpacity={0.9}
    />


    <FlareStackFlame
      FIC_2985={FIC_2985}
      FIC_2981={FIC_2981}
      FIC_2983={FIC_2983}
      isXV2983Open={!valves.XV_2983}
      isXV2982Open={!valves.XV_2982}
      x={1173}
      y={-60}
    />
        



    </div>
  );
}


export default Flare;